<nz-form-item class="label-on-top">
  <nz-form-label *ngIf="label" [nzRequired]="isRequired(control)">
    {{ label }}
  </nz-form-label>
  <nz-form-control nzHasFeedback [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    <nz-range-picker
      [formControl]="control"
      (ngModelChange)="onChange($event)"
      [nzDisabled]="isDisabled"
      [nzPlaceHolder]="[placeholder, placeholder]"
      [nzSize]="size"
      [nzDropdownClassName]="placement"
    >
    </nz-range-picker>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>
